enum AdSdkProvider {
  IMA = 'ima_sdk',
  TEADS = 'teads_sdk',
}

export { AdSdkProvider };
